/**
 * 课程标准 api
 * 课程标准api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The PaperVo model module.
   * @module course_standard/model/PaperVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>PaperVo</code>.
   * @alias module:course_standard/model/PaperVo
   * @class
   */
  var exports = function() {
    var _this = this;









  };

  /**
   * Constructs a <code>PaperVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:course_standard/model/PaperVo} obj Optional instance to populate.
   * @return {module:course_standard/model/PaperVo} The populated <code>PaperVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'type')) {
        obj['type'] = ApiClient.convertToType(data['type'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'randomNum')) {
        obj['randomNum'] = ApiClient.convertToType(data['randomNum'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'genFinished')) {
        obj['genFinished'] = ApiClient.convertToType(data['genFinished'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'courseStandardId')) {
        obj['courseStandardId'] = ApiClient.convertToType(data['courseStandardId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'gmtCreate')) {
        obj['gmtCreate'] = ApiClient.convertToType(data['gmtCreate'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'gmtModified')) {
        obj['gmtModified'] = ApiClient.convertToType(data['gmtModified'], 'Date');
      }
    }
    return obj;
  }

  /**
   * userExamId
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 0:固定选题组卷，1:知识点随机组卷
   * @member {Integer} type
   */
  exports.prototype['type'] = undefined;
  /**
   * 随机组卷数量，固定选题组卷不填
   * @member {Integer} randomNum
   */
  exports.prototype['randomNum'] = undefined;
  /**
   * 0未组卷 1组卷完成 -1组卷中
   * @member {Integer} genFinished
   */
  exports.prototype['genFinished'] = undefined;
  /**
   * 试卷名称
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * 课程 标准id
   * @member {Integer} courseStandardId
   */
  exports.prototype['courseStandardId'] = undefined;
  /**
   * 创建时间
   * @member {Date} gmtCreate
   */
  exports.prototype['gmtCreate'] = undefined;
  /**
   * 更新时间
   * @member {Date} gmtModified
   */
  exports.prototype['gmtModified'] = undefined;



  export default exports;
;


